if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const doc = new DOMParser().parseFromString(responseText, 'text/html');
            const section = doc.querySelector('section[id^="MainProduct-"]');
            if (!section) return;

            const sectionId = section.dataset.section;
            section.innerHTML = section.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
            section.querySelectorAll('variant-selects, variant-radios, product-info').forEach((el) => {
              el.dataset.originalSection = sectionId;
            });

            this.buildDrawer(section, doc);
            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
          });
      }

      buildDrawer(section, doc) {
        const drawer = document.createElement('div');
        drawer.classList.add('quick-add-drawer');

        // Grab ALL style tags from the product section for proper styling
        const allStyles = section.querySelectorAll('style');
        allStyles.forEach(s => {
          drawer.appendChild(s.cloneNode(true));
        });

        // Also grab styles from <head> that might be relevant
        const headStyles = doc.querySelectorAll('link[rel="stylesheet"][href*="section-main-product"], link[rel="stylesheet"][href*="component-price"]');
        headStyles.forEach(s => drawer.appendChild(s.cloneNode(true)));

        // === HEADER: title + close ===
        const header = document.createElement('div');
        header.classList.add('quick-add-drawer__header');

        const left = document.createElement('div');
        left.classList.add('quick-add-drawer__header-left');

        // Title — get from page <title> tag (most reliable), fallback to DOM
        let titleText = '';
        const pageTitle = doc.querySelector('title');
        if (pageTitle) {
          // Page title is usually "Product Name – Store Name" or "Product Name | Store Name"
          titleText = pageTitle.textContent.split('–')[0].split('|')[0].split('—')[0].trim();
        }
        if (!titleText) {
          const titleEl = section.querySelector('h1') || section.querySelector('h2') || section.querySelector('.product__title');
          if (titleEl) titleText = titleEl.textContent.trim();
        }

        if (titleText) {
          const titleDiv = document.createElement('div');
          titleDiv.classList.add('quick-add-drawer__title');
          titleDiv.textContent = titleText;
          left.appendChild(titleDiv);
        }

        // Price — clone the entire price wrapper to keep theme styling
        const priceWrapper = section.querySelector('[id^="price-"]');
        if (priceWrapper) {
          const priceClone = priceWrapper.cloneNode(true);
          left.appendChild(priceClone);
        }

        header.appendChild(left);

        // Close button
        const close = document.createElement('button');
        close.classList.add('quick-add-drawer__close');
        close.type = 'button';
        close.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1 1L17 17M17 1L1 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        close.addEventListener('click', () => this.hide());
        header.appendChild(close);
        drawer.appendChild(header);

        // === IMAGES ===
        const mediaImgs = section.querySelectorAll('.product__media-item img');
        if (mediaImgs.length > 0) {
          const row = document.createElement('div');
          row.classList.add('quick-add-drawer__images');
          const seen = new Set();

          // Pre-create all image elements
          const imgElements = [];
          mediaImgs.forEach(img => {
            const rawSrc = img.getAttribute('src') || '';
            const baseSrc = rawSrc.split('?')[0];
            if (!baseSrc || seen.has(baseSrc)) return;
            seen.add(baseSrc);

            const i = document.createElement('img');
            i.src = rawSrc;
            if (img.srcset) i.srcset = img.srcset;
            i.alt = img.alt || '';
            i.loading = 'eager';
            i.decoding = 'sync';
            imgElements.push(i);
            row.appendChild(i);
          });

          if (row.children.length > 0) {
            drawer.appendChild(row);
          }
        }

        // === VARIANT PICKER — clone with full wrapper for styling ===
        const variantRadios = section.querySelector('variant-radios');
        const variantSelects = section.querySelector('variant-selects');
        const vp = variantRadios || variantSelects;

        if (vp) {
          vp.setAttribute('data-update-url', 'false');
          const wrap = document.createElement('div');
          wrap.classList.add('quick-add-drawer__variants');

          // Clone the variant picker element itself
          const vpClone = vp.cloneNode(true);
          
          // Remove size chart modals/popups from the clone
          vpClone.querySelectorAll('modal-dialog, .product-popup-modal, .product-popup-modal__opener').forEach(el => el.remove());

          wrap.appendChild(vpClone);
          drawer.appendChild(wrap);
        }

        // === BUY BUTTONS ===
        const pf = section.querySelector('product-form');
        if (pf) {
          const fw = document.createElement('div');
          fw.classList.add('quick-add-drawer__form');
          fw.appendChild(pf.cloneNode(true));
          drawer.appendChild(fw);
        }

        // Render into modal
        this.modalContent.innerHTML = '';
        this.modalContent.appendChild(drawer);

        // Re-inject scripts for custom elements to work
        this.modalContent.querySelectorAll('script').forEach(old => {
          const s = document.createElement('script');
          Array.from(old.attributes).forEach(a => s.setAttribute(a.name, a.value));
          s.appendChild(document.createTextNode(old.innerHTML));
          old.parentNode.replaceChild(s, old);
        });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach(old => {
          const s = document.createElement('script');
          Array.from(old.attributes).forEach(a => s.setAttribute(a.name, a.value));
          s.appendChild(document.createTextNode(old.innerHTML));
          old.parentNode.replaceChild(s, old);
        });
      }
    }
  );
}